// Shared bits for the ChatGPT Commerce (ACP) tab — matches the Catalogue card/badge styling.
export const STATUS_STYLES = {
  connected: "bg-emerald-50 text-emerald-700 border-emerald-100",
  active: "bg-emerald-50 text-emerald-700 border-emerald-100",
  test_mode: "bg-violet-50 text-violet-700 border-violet-100",
  pending: "bg-amber-50 text-amber-700 border-amber-100",
  pending_approval: "bg-amber-50 text-amber-700 border-amber-100",
  not_connected: "bg-zinc-100 text-zinc-600 border-zinc-200",
  published: "bg-emerald-50 text-emerald-700 border-emerald-100",
  eligible: "bg-zinc-100 text-zinc-600 border-zinc-200",
  error: "bg-rose-50 text-rose-700 border-rose-100",
  inactive: "bg-zinc-100 text-zinc-500 border-zinc-200",
};
export const STATUS_LABELS = {
  connected: "Connected", active: "Active", test_mode: "Test Mode", pending: "Pending", pending_approval: "Pending Approval",
  not_connected: "Not Connected", published: "Published", eligible: "Unpublished", error: "Errors", inactive: "Inactive",
};

export function StatusPill({ status, testId }) {
  return (
    <span className={`inline-flex items-center text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5 rounded border ${STATUS_STYLES[status] || STATUS_STYLES.not_connected}`} data-testid={testId}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export function StatCard({ label, value, tone = "zinc", testId }) {
  const tones = { zinc: "text-zinc-900", green: "text-emerald-700", purple: "text-violet-700", red: "text-rose-700" };
  return (
    <div className="rounded-2xl bg-white border border-zinc-200 px-4 py-3" data-testid={testId}>
      <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold">{label}</div>
      <div className={`text-2xl font-bold mt-1 ${tones[tone]}`}>{value}</div>
    </div>
  );
}

export function Section({ title, children, right }) {
  return (
    <div className="rounded-2xl bg-white border border-zinc-200 p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="text-sm font-semibold text-zinc-900">{title}</div>
        {right}
      </div>
      {children}
    </div>
  );
}

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "Never");
export const money = (n) => `$${Number(n || 0).toFixed(2)}`;
